import Bathroom1 from '../questionsData/residential/firstFloor/Bathroom'
import Bedroom1 from '../questionsData/residential/firstFloor/Bedroom'
import Kitchen from '../questionsData/residential/firstFloor/Kitchen'
import LivingRoom from '../questionsData/residential/firstFloor/LivingRoom'
import Bathroom2 from '../questionsData/residential/secondFloor/Bathroom'
import Bedroom2 from '../questionsData/residential/secondFloor/Bedroom'
import ResidentialExteriors from '../QuestionsData/residential/exteriors';

import FileRoom from '../questionsData/commercial/firstFloor/FileRoom'
import Lobby from '../questionsData/commercial/firstFloor/Lobby'
import Warehouse from '../questionsData/commercial/firstFloor/Warehouse'
import ParkingArea from '../questionsData/commercial/firstFloor/ParkingArea'
import CommercialExteriors from '../QuestionsData/residential/exteriors';

const residentialQuestions = [
  Kitchen,
  LivingRoom,
  Bathroom1,
  Bedroom1,
  Bedroom2,
  Bathroom2
]

const commercialQuestions = [
  ParkingArea,
  Warehouse,
  FileRoom,
  Lobby
]

export const returnInitialStore = (selected) => {
  selected = selected == null ? 'residential' : selected;
  let state = {
    selected: selected,
    residential: {
      url: "/static/house/housev4.json",
      meshes: new Map(),
      textures: new Map()
    },
    commercial: {
      url: "/static/commercial/Servpro_05.gltf",
      meshes: new Map(),
      textures: new Map()
    },
    get rooms() {
      return this.selected == 'residential' ? this.residential.rooms : this.commercial.rooms;
    },
    get meshes() {
      return this.selected == 'residential' ? this.residential.meshes : this.commercial.meshes;
    },
    get textures() {
      return this.selected == 'residential' ? this.residential.textures : this.commercial.textures;
    }
  };

  const setupRooms = (el, index) => {
    const roomData = {
      name: el.name,
      id: el.id,
      score: 0,
      totalQuestions: el.data.length,
      questions: el.data,
      roomIndex: index
    };

    roomData.questions = roomData.questions.map((question, questionIndex) => {
      question.roomIndex = index;
      question.questionIndex = questionIndex;
      question.completed = false;
      question.selectedIndex = null;

      return question;
    });

    return roomData
  };

  state.residential.rooms = residentialQuestions.map(setupRooms);
  state.commercial.rooms = commercialQuestions.map(setupRooms);

  state.totalScore = 0;
  state.questionsCompleted = 0;
  state.clickedObj = null;

  return state
}

export const returnFinishGameStore = () => {
  let state = {
    residential: {},
    commercial: {}
  };

  var setupFinishedState = (el, index) => {
    const roomData = {
      name: el.name,
      id: el.id,
      score: 0,
      totalQuestions: el.data.length,
      questions: el.data,
      roomIndex: index
    };

    roomData.questions = roomData.questions.map((question, questionIndex) => {
      question.roomIndex = index;
      question.questionIndex = questionIndex;

      return question;
    });

    return roomData
  };

  state.residential.rooms = residentialQuestions.map(setupFinishedState);
  state.commercial.rooms = commercialQuestions.map(setupFinishedState);

  state.totalScore = 0;
  state.questionsCompleted = 17;
  state.clickedObj = null;

  return state
}



// WEBPACK FOOTER //
// ./src/assets/utils/initStore.js